import styled, { css } from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  heading: {
    marginLeft: 24,
    color: theme.palette.primary.main,
    fontWeight: 400,
    lineHeight: 'normal',
    fontSize: 24,
  },
  title: {
    fontWeight: 400,
    color: theme.palette.common.second3,
  },
  text: {
    fontSize: 18,
    color: theme.palette.common.second1,
    fontWeight: 400,
    marginRight: '10px',
  },
}))

export const Root = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: 31px 64px 34px 28px;
    display: flex;
    flex-flow: column;
    border: 1px solid ${theme.palette.common.second6};
    border-radius: 4px;
  `}
`

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 250px;
  column-gap: 65px;
  margin-left: 52px;
  margin-top: 27px;
`

export const Card = styled.div`
  ${({ theme }) => css`
    border: 2px solid ${theme.palette.common.second6};
    border-radius: 5px;
    padding: 0 30px;
    cursor: pointer;
  `}
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`
